export const BANNER_STATUS = {
	ON_SALE: "onSale", // 上線
	OFF_SALE: "offSale", // 下架
	AFTER_SALE: "afterSale", // 已結束
	BEFORE_SALE: "beforeSale", // 未上線
};
